import React, { useCallback, useState } from 'react';
import useFormSubmit from '../../lib/SubmitForm';
import FormMessages from './parts/FormMessages';
import SubmitButton from './parts/SubmitButton';

const GeneralContactForm = () => {
    const { submitForm } = useFormSubmit();
    const [subject, setSubject] = useState('');
    const [fullname, setFullname] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errors, setErrors] = useState([]);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const performSubmit = useCallback(async () => {
        setIsSubmitting(true);
        const data = {
            form_name: 'General Contact',
            fields: [
                { label: 'Subject', value: subject },
                { label: 'Name', value: fullname },
                { label: 'Company Name', value: companyName },
                { label: 'Email', value: email },
                { label: 'Phone', value: phone },
                { label: 'Message', value: message },
            ],
        };

        const formData = new FormData();
        formData.append('data', JSON.stringify(data));

        const result = await submitForm(formData);

        setErrors([...result?.errors]);
        setIsSubmitted(result?.isSubmitted);

        setIsSubmitting(false);
    }, [companyName, email, fullname, message, phone, subject, submitForm]);

    const handleSubmit = (e) => {
        e.preventDefault();
        performSubmit();
    };

    return (
        <form onSubmit={handleSubmit} action="#" method="post" className="row contact-form ">
            <FormMessages isSubmitted={isSubmitted} errors={errors} />

            <div className="col-md-6">
                <input
                    required
                    value={fullname}
                    onChange={(e) => setFullname(e.target.value)}
                    type="text"
                    placeholder="Full Name"
                />
            </div>
            <div className="col-md-6">
                <input
                    required
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    type="text"
                    placeholder="Company Name"
                />
            </div>
            <div className="col-md-6">
                <input
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="email"
                    placeholder="Email Address"
                />
            </div>
            <div className="col-md-6">
                <input
                    required
                    type="text"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="Phone Number"
                />
            </div>
            <div className="col-md-12">
                <input
                    required
                    type="text"
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    placeholder="Subject"
                />
            </div>
            <div className="col-md-12">
                <textarea
                    required
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Additional Message"
                ></textarea>
            </div>
            <div className="col-md-12 text-center">
                <SubmitButton isSubmitting={isSubmitting} label="Send Message" />
            </div>
        </form>
    );
};

export default GeneralContactForm;
